import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import CurrencyFilterList from 'components/CurrencyFilter/List';

const ScreenCurrencyFilterList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <CurrencyFilterList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};
export default ScreenCurrencyFilterList;
